import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black text-white/60 py-12 px-6 text-center text-sm" data-id="element-102">
      <div className="max-w-4xl mx-auto" data-id="element-103">
        <p className="mb-4" data-id="element-104">
          © {new Date().getFullYear()} Bienestar Digital. Todos los derechos
          reservados.
        </p>
        <p className="text-xs opacity-50 max-w-2xl mx-auto" data-id="element-105">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}